// AgroBook Design System Colors
// Extracted from DESIGN/agrobook_prototype.html
export const colors = {
  // Avatar color palette — gradient stop pairs used by the Avatar component.
  // Add new avatar color options here; Avatar.tsx reads these automatically.
  avatarColors: {
    coral:  { from: '#ff6b6b', to: '#ff8c8c' },
    mint:   { from: '#51cf66', to: '#69db7c' },
    purple: { from: '#9775fa', to: '#b197fc' },
    sky:    { from: '#4dabf7', to: '#74c0fc' },
    rose:   { from: '#f06595', to: '#f783ac' },
    yellow: { from: '#ffd43b', to: '#ffec99' },
    sage:   { from: '#8ce99a', to: '#a9e34b' },
    peach:  { from: '#ff922b', to: '#ffa94d' },
    teal:   { from: '#20c997', to: '#51cf66' },
  },
  white: '#ffffff',
  // Primary green palette
  green: {
    900: '#1B4332',
    800: '#2D6A4F',
    700: '#40916C',
    600: '#52B788',
    400: '#95D5B2',
    200: '#D8F3DC',
    100: '#EFF9F2',
    50: '#F8FDF9',
  },
  // Earth tones
  earth: {
    DEFAULT: '#7C5C3E',
    light: '#F0E6DA',
    50: '#FAF4EE',
  },
  // Accent color — also used for Upcoming status tinting
  amber: {
    DEFAULT: '#E9A227',
    200: '#fde68a',  // outer border (Upcoming results)
    100: '#fef9c3',  // row / card separators
    50: '#FEF9EC',   // warm ivory — pre-existing value, used by ModuleCard, InviteModal, CustomerLogsPage, SuperAdminOrgView
  },
  // Blue (used for Regions module card icon background)
  blue: {
    50: '#EFF6FF',
  },
  // Error / destructive red
  red: {
    600: '#dc2626',  // error text, icons
    200: '#fecaca',  // error border
  },
  // Gray scale
  gray: {
    900: '#111827',
    700: '#374151',
    500: '#6B7280',
    400: '#9CA3AF',
    300: '#D1D5DB',
    100: '#F3F4F6',
    50: '#F9FAFB',
  },
};
